import type { PaginationContext } from './pagination.types'

import { createContext } from '../utils'

const [PaginationProvider, usePaginationContext] = createContext<PaginationContext>({ isOptional: true })

export { PaginationProvider, usePaginationContext }
